import { useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { Form } from "antd";
import AmendBondContract from "./AmendBondContract";
import ApproveBondContract from "./ApproveBondContract";
import DisburseBondContract from "./DisburseBondContract";
import RejectBondContract from "./RejectBondContract";
import TerminateBondContract from "./TerminateBondContract";
import TerminateCallableBondContract from "./TerminateCallableBondContract";

const BondMainActionPage = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();

  const renderActions = () => {
    switch (state?.actionLabel?.toLowerCase()) {
      // case "modify application":
      //   return <ModifySavingsAccount userData={userData} />;
      case "approve deal":
        return <ApproveBondContract userData={userData} />;
      case "disburse deal":
        return <DisburseBondContract userData={userData} />;
      case "reject deal":
        return <RejectBondContract userData={userData} />;
      case "amend deal":
        return <AmendBondContract userData={userData} />;
      case "terminate puttable deal":
        return <TerminateBondContract userData={userData} />;
      case "terminate callable deal":
        return <TerminateCallableBondContract userData={userData} />;

      // case "close":
      //   return <CloseSavingsAcc userData={userData} />;

      default:
        return <>No {state.actionLabel} Component found contact dev</>;
    }
  };
  return <>{renderActions()}</>;
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
export default connect(mapStateToProps, null)(BondMainActionPage);
